module.exports = __webpack_public_path__ + "static/media/003-boy.70fc8de1.svg";